import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { storage } from '@uhg-abyss/web/tools/storage';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { IdleUser } from '@sde/widgets-core/src/widgets/IdleUser';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';

export const IdleUserWidget = () => {
  const { user } = useUser.state();
  const { validateUser } = useUser.actions();
  const handleLogout = () => {
    storage.session.remove('selectedTab');
    const permissionsStorageKey = 'provider-permissions';
    storage.local.remove(permissionsStorageKey);
    storage.session.remove('session-expiry-time');
    window.location.href = `${
      getFeature('OHID_SESSION_REWORK')
        ? `${config('IDENTITY_API_URL_BREAKOUT')}/logout/v2`
        : `${config('IDENTITY_API_URL_BREAKOUT')}/logout`
    }`;
  };

  const widgetProps = {
    data: {
      idleStorageKey: 'seamless:idle-url',
    },
    events: {
      showIdleRecovery: () => {
        return window.location.hash === '#/' && user.uuid;
      },
      setIdleRecovery: () => {
        return window.location.hash !== '#/';
      },
      onIdleTick: () => {
        validateUser(
          () => null,
          (e) => {
            if (e.status === 401) {
              handleLogout();
            }
          }
        );
      },
      onSignout: () => {
        handleLogout();
      },
    },
  };

  return <IdleUser {...widgetProps} />;
};
